/**
 * 空页面：菜单尚未实现时统一展示「页面内容为空」提示。
 * 设计（LEO 规范 §7 反馈原则 + §1.2 避免白底）。
 */

interface Props {
  title: string;
}

export function EmptyPage({ title }: Props) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="leo-card flex max-w-[460px] flex-col items-center rounded-2xl px-10 py-10 text-center">
        <span className="mb-4 grid h-12 w-12 place-items-center rounded-2xl bg-line-subtle text-text-muted">
          <svg
            viewBox="0 0 24 24"
            className="h-6 w-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.75}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </span>
        <div className="font-display text-[1.05rem] font-semibold text-text-emphasis">
          {title}
        </div>
        <div className="mt-1.5 text-[12px] text-text-muted">页面内容为空</div>
      </div>
    </div>
  );
}